import RewardsBanner from './RewardsBanner';
import { connect } from 'react-redux';
import { AppState } from '../../interfaces';
const mapStateToProps = (state: AppState) => ({
  rewards: state.rewardsReducer,
});
export default connect(mapStateToProps, null)(RewardsBanner);
